import { IAttendeeOrganizationDTO } from '../../api/attendees.dao';

type SearchableMeeting = {
    topic: string;
    meetingId: number;
    hosts: IAttendeeOrganizationDTO[];
    presenters: IAttendeeOrganizationDTO[];
    participants: IAttendeeOrganizationDTO[];
};

export const meetingMatchesSearch = <T extends SearchableMeeting>(meeting: T, term: string): boolean => {
    const lowerTerm = (term || '').trim().toLowerCase();

    // Topic or IDs first (fastest checks)
    if ((meeting.topic || '').toLowerCase().includes(lowerTerm)) return true;
    if (meeting.meetingId.toString().includes(term)) return true;

    const roles = [
        meeting.hosts || [],
        meeting.presenters || [],
        meeting.participants || []
    ];

    // Check ALL organization names first (shallow level)
    if (roles.some(roleArray =>
        roleArray.some(role => role.name.toLowerCase().includes(lowerTerm))
    )) {
        return true;
    }

    // Only if no org names matched, then check attendee names (deep level)
    return roles.some(roleArray =>
        roleArray.some(role =>
            (role.attendees || []).some(a => {
                const fullName = `${a.firstName} ${a.lastName}`.toLowerCase();
                return fullName.includes(lowerTerm);
            })
        )
    );
};
